import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=6aea51e3"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=6aea51e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports